import React from 'react';
import { Provider } from "react-redux"
import ReactDOM from 'react-dom';
import Store from "./store"

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<Provider store={Store}><App /></Provider>, document.getElementById('App'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
